<template>
  <v-container>
    <v-toolbar class="mb-3">
      <v-toolbar-title>
        {{ $t('admin.personrole.addUser') }}
      </v-toolbar-title>

      <h2 class="ml-4">
        {{ $store.getters.currentCustomer?.title }}
      </h2>

      <v-spacer></v-spacer>

      <v-btn
        :loading="saving"
        :disabled="!loadingRoles && !roles.length"
        @click="create"
      >
        <v-icon left> mdi-account-plus </v-icon>
        {{ $t('admin.personrole.create') }}
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-card-text>
        <v-alert v-if="!loadingRoles && !roles.length" type="warning">
          Der er ingen roller på kunden og det er derfor ikke muligt at oprette brugere!
        </v-alert>
        <v-form ref="form" v-model="valid" :disabled="!roles.length">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="user.firstName"
                label="Fornavn"
                :rules="[rules.required]"
                outlined
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="user.lastName"
                label="Efternavn"
                :rules="[rules.required]"
                outlined
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="user.email"
            label="E-mail"
            :rules="[rules.required, rules.email]"
            outlined
          />
          <v-row>
            <v-col cols="12" md="6">
              <tel-input-component
                v-model="user.phone"
                name="phone"
                placeholder="Telefonnummer"
              />
            </v-col>
            <v-col cols="12" md="6">
              <tel-input-component
                v-model="user.cellPhone"
                name="phone"
                placeholder="Mobilnummer"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="user.title"
                label="Titel"
                :rules="[rules.required]"
                outlined
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="user.organizationId"
                :items="organizations"
                :rules="[rules.required]"
                label="Organisation"
                item-text="title"
                item-value="id"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-alert type="warning" text>
                Du er ved at oprette en bruger på kunden: <strong>{{ $store.getters.currentCustomer.title }}</strong>
              </v-alert>
              <v-select
                v-model="user.customerRoleIds"
                :items="roles"
                label="Roller"
                :rules="[rules.required]"
                item-value="id"
                item-text="title"
                
                multiple
                clearable
                outlined
              />
            </v-col>
          </v-row>
        </v-form>

        <v-alert type="info" text v-if="user.federationReference">
          Federation reference: <ClipboardCopy>
            <tt>{{ user.federationReference }}</tt>
          </ClipboardCopy>
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import TelInputComponent from '@/components/TelInputComponent.vue';
import ClipboardCopy from '@/components/ClipboardCopy.vue';

export default {
  name: 'UserCreate',
  components: { TelInputComponent, ClipboardCopy },
  data() {
    return {
      loading: true,
      loadingRoles: true,
      saving: false,
      valid: false,
      user: {
        firstName: null,
        lastName: null,
        email: null,
        title: null,
        phone: null,
        cellPhone: null,
        organizationId: null,
      },
      organizations: [],
      roles: [],
      rules: {
        required: value => !!value || 'Skal udfyldes',
        email: value => !!value?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/) || 'Indtast en gyldig e-mail'
      }
    }
  },
  mounted() {
    this.loading = true;

    this.$api.get('organizations').then(res => {
      this.organizations = res.data;
    })
    this.getRoles();

    this.loading = false;

    if (this.$route.query) {
      const { name, email, federationReference } = this.$route.query;

      const [firstName, ...rest] = name.split(' ')


      this.user.firstName = firstName;
      this.user.lastName = rest.join(' ');
      this.user.email = email;
      this.user.federationReference = federationReference;
    }
  },
  methods: {
    getRoles: async function() {
      this.loadingRoles = true;

      try {
        const { data } = await this.$api.get('roles', {
          params: {
            customerId: this.$store.state.primaryCustomerId
          }
        });

        this.roles = data;
      } catch (error) {
        this.$notifier.showError({});
      } finally {
        this.loadingRoles = false;
      }
    },
    create: async function(navigateAfterCreation = true) {
      if (!this.$refs.form.validate()) return

      try {
        this.saving = true;
        
        const { data } = await this.$api.post('users', this.user);

        if (data.errors.length || !data.success) throw data.errors[0] ?? data.message

        this.$notifier.showSuccess({ message: 'Brugeren blev oprettet' });

        this.$refs.form.reset()

        if (navigateAfterCreation) {
          this.$router.push('/admin/user-edit/' + data.model)
        }
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.saving = false;
      }
    }
  }
}
</script>